export function chatMoreOptions() {
    // Remove any previously-bound handlers to avoid duplicates on AJAX re-init
    $(document).off('click.chatMoreOptions');
    $(document).off('show.bs.modal.chatMoreOptions');

    // Use a native capture-phase listener so we run BEFORE Bootstrap
    // stops propagation on [data-bs-toggle] elements.
    document.removeEventListener('click', _chatMoreOptionsCapture, true);
    document.addEventListener('click', _chatMoreOptionsCapture, true);

    // Toggle open/close when clicking the ellipsis icon (not the list)
    $(document).on('click.chatMoreOptions', '.g-chat-btn-more-options', function (event) {
        if ($(event.target).closest('.g-chat-btn-more-options-list').length) {
            // Item inside list was clicked — close (capture handler covers it,
            // but do it here too as a fallback)
            $(this).removeClass('is-open');
            return;
        }
        event.stopPropagation();
        $(this).toggleClass('is-open');
    });

    // Also close when any Bootstrap modal is about to show
    // (covers [data-bs-toggle="modal"] items whose click Bootstrap intercepts)
    $(document).on('show.bs.modal.chatMoreOptions', function () {
        $('.g-chat-btn-more-options').removeClass('is-open');
    });

    // Close when clicking anywhere outside the component
    $(document).on('click.chatMoreOptions', function (event) {
        if (!$(event.target).closest('.g-chat-btn-more-options').length) {
            $('.g-chat-btn-more-options').removeClass('is-open');
        }
    });
}

// Capture-phase handler: fires before Bootstrap's stopPropagation
function _chatMoreOptionsCapture(event) {
    if (event.target.closest('.g-chat-btn-more-options-list')) {
        const container = event.target.closest('.g-chat-btn-more-options');
        if (container) {
            container.classList.remove('is-open');
        }
    }
}
